import React from "react";

const HistorySection = ({ winnerHistory, handleClearWinnerHistory }) => (
  <div className="border">
    <h3 className="d-flex justify-content-between align-items-center mt-1">
      Winner History
      <button
        className="btn btn-danger btn-sm"
        onClick={handleClearWinnerHistory}
      >
        Clear History
      </button>
    </h3>
    <ul className="list-group mb-3">
      {winnerHistory.map((winner, index) => (
        <li key={index} className="list-group-item">
          {winner}
        </li>
      ))}
    </ul>
  </div>
);

export default HistorySection;
